<title>{{ orderChangeNotifRegistrationPage.htmlTitle }}</title>
<app-banner [banner]="orderChangeNotifRegistrationPage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>
<div id="confpn-voucher" class="conf" *ngIf="orderChangeNotifSuccess">
  <div id="confDet" class="conf">
    <i class="fa fa-check-circle"></i>
    {{ OCNregisterLabels.successMsg }}
  </div>
</div>
<div id="errorpn-VoucherRedeem" *ngIf="orderChangeNotifError">
  <div id="errDet" class="err-VoucherRedeem">
    {{ orderChangeNotifError }}
  </div>
</div>
<div id="pnfm" *ngIf="!orderChangeNotifSuccess">
  <div class="container">
    <form [formGroup]="orderChageNotifRegisterForm">
      <div class="row">
        <div class="offset-sm-1 col-sm-10">
          <div class="brd commonFormsCss">
            <div class="row">
              <div class="col-sm-12">
                <div class="pd-15">
                  <h3>{{ OCNregisterLabels.mainHeading }}</h3>
                  <p>
                    {{ OCNregisterLabels.note }}
                  </p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-5">
                <div class="form-group pl-15">
                  <span class="sml">{{ OCNregisterLabels.Environment }}</span>
                  <select id="chk-env" name="chk-env" formControlName="environment" class="form-control">
                    <ng-container *ngFor="let option of OCNregisterLabels.optionTEST">
                      <option [value]="option">{{ option }}</option>
                    </ng-container>
                    <ng-container *ngFor="let option of OCNregisterLabels.optionLIVE">
                      <option [value]="option">{{ option }}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-5">
                <div class="form-group pl-15">
                  <span class="sml">{{ OCNregisterLabels.AgencyNameServiceProvider }}</span
                  ><br />
                  <input type="text" formControlName="agencyName" maxlength="100" placeholder="Agency Name" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['agencyName'].errors }" />
                  <div class="field-validation-valid text-danger" *ngIf="submitted && f['agencyName'].errors">
                    {{ OCNregisterLabels.invalidAgencyName }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group pl-15">
                  <span class="sml">{{ OCNregisterLabels.ContactName }}</span
                  ><br />
                  <input
                    type="text"
                    formControlName="contactName"
                    maxlength="30"
                    placeholder="First Name   Last Name"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f['contactName'].errors }"
                  />
                  <div class="field-validation-valid text-danger" *ngIf="submitted && f['contactName'].errors">{{ OCNregisterLabels.invalidContactName }}</div>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group">
                  <span class="sml">{{ OCNregisterLabels.ContacteMail }}</span
                  ><br />
                  <input type="text" formControlName="contactEmail" placeholder="eMail " class="form-control" [ngClass]="{ 'is-invalid': submitted && f['contactEmail'].errors }" />
                  <div class="field-validation-valid text-danger" *ngIf="submitted && f['contactEmail'].errors">{{ OCNregisterLabels.invalidMailAdress }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group pl-15">
                  <span class="sml">{{ OCNregisterLabels.MasheryUserName }}</span
                  ><br />

                  <input
                    type="{{ showPassword ? 'text' : 'password' }}"
                    maxlength="255"
                    formControlName="masheryUserName"
                    placeholder="API gateway username"
                    [ngClass]="{ 'is-invalid': submitted && f['masheryUserName'].errors }"
                    class="form-control form-control-sm masheryUserName-input"
                  />
                  <a (click)="togglePassword()" class="eye-b field-icon">
                    <i class="{{ showPassword ? 'fas fa-eye' : 'fas fa-eye-slash' }}"></i>
                  </a>
                  <div class="field-validation-valid text-danger" *ngIf="submitted && f['masheryUserName'].errors">Please enter your API Gateway UserName</div>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group">
                  <span id="envtit" class="sml">{{ OCNregisterLabels.MasheryPackageKey }}</span
                  ><br />

                  <input
                    type="{{ showText ? 'text' : 'password' }}"
                    formControlName="masheryClientKey"
                    placeholder="clientkey"
                    maxlength="255"
                    (keypress)="keyPressSpace($event)"
                    class="form-control form-control-sm"
                    [ngClass]="{ 'is-invalid': submitted && f['masheryClientKey'].errors }"
                  />

                  <a (click)="toggleMasheryText()" class="eye-b field-icon">
                    <i class="{{ showText ? 'fas fa-eye' : 'fas fa-eye-slash' }}"></i>
                  </a>
                  <div class="field-validation-valid text-danger" *ngIf="submitted && f['masheryClientKey'].errors">Please enter your API Gateway Package Key</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group pl-15">
                  <span class="sml">{{ OCNregisterLabels.IATAServiceProvider }}</span
                  ><br />
                  <div class="input-group">
                    <input
                      id="iatan"
                      name="iatan"
                      type="text"
                      class="form-control"
                      maxlength="8"
                      placeholder="00000000"
                      formControlName="IATAserviceProvider"
                      (keypress)="keyPressNumbers($event)"
                      (focus)="clearErrorMesssage()"
                      [ngClass]="{ 'is-invalid': IATAAdded && f['IATAserviceProvider'].errors }"
                    />

                    <div class="input-group-btn">
                      <button type="button" (click)="addIATA()" class="btn btn-mnu btn-addon">{{ OCNregisterLabels.add }}</button>
                    </div>
                  </div>
                  <div class="field-validation-valid text-danger" *ngIf="showDuplicateVoucherError">IATA number already added</div>
                  <div class="field-validation-valid text-danger" *ngIf="IATAAdded && f['IATAserviceProvider'].errors">IATA number must 8 characters long</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group pl-15">
                  <div class="mb-10 mt-10 brd-ns" [ngClass]="{ 'is-invalid': submitted && !IATANumbers.length }">
                    <h6>{{ OCNregisterLabels.IATAServiceProvider }}</h6>
                    <div id="pniatas">
                      <ul class="no-bullets">
                        <li *ngFor="let IATA of IATANumbers">
                          <a (click)="delIATAnum(IATA)"><i class="fa fa-trash"></i></a>{{ IATA }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="field-validation-valid text-danger" *ngIf="submitted && !IATANumbers.length">Please enter IATA number</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5"></div>
              <div class="col-sm-5">
                <div class="form-group">
                  <span class="sml">{{ OCNregisterLabels.Protocol }}</span
                  ><br />
                  <input type="radio" name="protocol" id="rd-soap" class="me-2" checked="" value="SOAP" formControlName="protocol" (change)="enbleSoapAction()" />
                  <b>{{ OCNregisterLabels.optionSOAP }}</b>
                  <input type="radio" name="protocol" id="rd-rest" class="radio-margin" value="REST" formControlName="protocol" (change)="disableSoapAction()" />
                  <b>{{ OCNregisterLabels.optionREST }}</b>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group pl-15">
                  <span class="sml">{{ OCNregisterLabels.EndPointURL }}</span
                  ><br />
                  <input type="text" formControlName="endpointUrl" placeholder="https://endpoint" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['endpointUrl'].errors }" />
                  <div class="field-validation-valid text-danger" *ngIf="submitted && f['endpointUrl'].errors">{{ OCNregisterLabels.invalidEndpointUrl }}</div>
                </div>
              </div>

              <div class="col-sm-5">
                <div id="pn-soap" class="form-group">
                  <span class="sml">{{ OCNregisterLabels.SoapAction }}</span
                  ><br />
                  <input type="text" formControlName="soapAction" placeholder="soapaction" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['soapAction'].errors }" />
                  <div class="field-validation-valid text-danger" *ngIf="submitted && f['soapAction'].errors">{{ OCNregisterLabels.invalidSOAPtext }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group pl-15">
                  <span class="sml">{{ OCNregisterLabels.AuthenticationMethod }}</span
                  ><br />
                  <input type="radio" name="authenticationMethod" id="rd-basicauth" class="me-2" checked="" value="BASIC" formControlName="authenticationMethod" (change)="disableAuth()" />
                  <b>{{ OCNregisterLabels.optionBasicAuth }}</b>
                  <input type="radio" name="authenticationMethod" id="rd-oauth" class="radio-margin" value="oAUTH2" formControlName="authenticationMethod" (change)="enableAuth()" />
                  <b>{{ OCNregisterLabels.optionOAuth20 }}</b>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <h5 class="pl-15">{{ OCNregisterLabels.APICredentialsHeading }}</h5>
                <div class="form-group pl-15">
                  <span class="sml">{{ OCNregisterLabels.TokenServiceURL }}</span
                  ><br />
                  <input
                    type="text"
                    [disabled]="true"
                    formControlName="tokenServiceUrl"
                    placeholder="https://endpoint"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f['tokenServiceUrl'].errors }"
                  />
                  <div class="field-validation-valid text-danger" *ngIf="submitted && f['tokenServiceUrl'].errors">
                    {{ OCNregisterLabels.invalidTokenServiceUrl }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group pl-15">
                  <span class="sml">{{ OCNregisterLabels.UserNameClientKey }}</span
                  ><br />
                  <input type="text" formControlName="userName" placeholder="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['userName'].errors }" />
                  <div class="field-validation-valid text-danger" *ngIf="submitted && f['userName'].errors">Please enter your UserName / Client Key</div>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group">
                  <span class="sml">{{ OCNregisterLabels.PasswordClientSecret }}</span
                  ><br />
                  <input
                    type="{{ showClientSecret ? 'text' : 'password' }}"
                    formControlName="clientSecret"
                    placeholder="password"
                    class="form-control form-control-sm masheryUserName-input"
                    [ngClass]="{ 'is-invalid': submitted && f['clientSecret'].errors }"
                  />

                  <a (click)="toggleClientSecret()" class="eye-b field-icon">
                    <i class="{{ showClientSecret ? 'fas fa-eye' : 'fas fa-eye-slash' }}"></i>
                  </a>
                  <div class="field-validation-valid text-danger" *ngIf="submitted && f['clientSecret'].errors">Please enter your Password / Client Secret</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-12 right-align">
              <button (click)="submitOrderChangeNotif()" type="button" role="button" class="btn ba-btn submit-btn pull-right"><i class="fa fa-edit"></i> {{ OCNregisterLabels.submit }}</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
